import script from "./CalendarOverlappingEvents.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarOverlappingEvents.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarOverlappingEvents.vue?vue&type=style&index=0&id=52821b96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52821b96"]])

export default __exports__